/**
 * 转场特效 - flipBook
 * 2019-6-5
 */
(function (root, factory) {
  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = factory(this);
  } else {
      factory(root);
  }
})(this, function (root) {
  // 类构造函数
  function con(scene, option) {
    this.code = option.code || 'FlipBook';
    this.maskEle = $('<div></div>').attr({ id: 'maskEle_' + scene.id });
    this.div1 = null;
    this.div2 = null;
    this.video1 = null;
    this.video2 = null;
  }

  var methods = {
    init: function (force) {
      var _this = this;
      this.duration = 1.5;
      this.startAt = 0.75;

      return this.supr(this.startAt, force).then(function () {
        _this.initDom();
      })
    },

    initDom: function () {
      if (this.maskEle) {
        this.maskEle.empty()
        var editor = this.scene.editor;
        
        this.div1 = $('<div></div>')
        this.cameraDom = this.scene.getTimeDom(this.scene.duration - this.startAt*1000)
        this.div1.css({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          transformStyle: 'preserve-3d',
          clipPath: 'polygon(49.95% 0, 100% 0, 100% 100%, 49.95% 100%)'
        }).append(this.cameraDom.attr({class: 'scenes-content'}));
        this.video1 = this.cameraDom.find('video')[0]
        this.div1.append($('<div></div>').css({
          position: 'absolute',
          top: 0,
          left: '50%',
          width: '50%',
          height: '100%',
          background: 'linear-gradient(to right, rgba(200,200,200,0.1), rgba(200,200,200,0.3))'
        }))
        if(this.nexts) {
          this.div2 = this.nexts.getTimeDom(this.startAt*1000)
          this.div2.css({
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            transformStyle: 'preserve-3d',
            clipPath: 'polygon(0 0, 50.05% 0, 50.05% 100%, 0 100%)'
          });
          this.video2 = this.div2.find('video')[0]
          this.div2.append($('<div></div>').css({
            position: 'absolute',
            top: 0,
            left: 0,
            width: '50%',
            height: '100%',
            background: 'linear-gradient(to left, rgba(200,200,200,0.1), rgba(200,200,200,0.3))'
          }))
        }else {
          this.div2 = null;
          this.video2 = null;
        }

        this.maskEle.css({
          width: editor.clientWidth + 'px',
          height: editor.clientHeight + 'px',
          position: 'absolute',
          top: 0,
          left: 0,
          perspective: '1200px'
        }).append(this.div1).append(this.div2).hide();

        // 插入播放层的 maskEle 中
        editor.player.maskEle.append(this.maskEle);
      }
    },

    show: function (frame) {
      // 播放
      if (!this.isInit) return;
      this.supr(frame);

      var scene = this.scene,
        editor = scene.editor,
        sEle = scene.element.player; // player层的当前 scene

      // 播放层显示，对应scene显示
      editor.player.ele.show();
      sEle.show();

      // 衔接上一个场景页的动画(e.g.前0.75s的动画)
      if (frame <= this.entrance.end) {
        this.showFirst(frame);
      }

      // 本场景页的转场动画(e.g.后0.75s的动画)
      if (this.nexts && frame >= this.exit.start) {
        // 隐藏上一个场景页的遮罩
        this.prevs && this.prevs.effect.maskEle && this.prevs.effect.maskEle.hide();

        var nexts_ele = this.nexts.element.player; // player层中的下一个场景
        var offFrame = frame - this.exit.start; // 当前帧减去动画开始时的帧
        
        nexts_ele.css({
          clipPath: 'polygon(50% 0, 100% 0, 100% 100%, 50% 100%)'
        }).show();
        this.div1.css({
          transform: 'rotateY(' + this.linear(offFrame, 0, -180, this.totalFrame)+ 'deg)',
        }).show();
        this.div2 && this.div2.hide()

        if(this.video1) {
          this.video1.currentTime = scene.background.element.playerVideo.prop('currentTime') || 0
        }

        this.maskEle.show();
      }

      // 动画外的时间
      if (frame > this.entrance.end && frame < this.exit.start) {
        this.showMiddle();
      }
    },

    // 为下一个场景提供方法以完成动画衔接
    showNext: function (frame) {
      var _currentFrame = this.startAt * this.frameRate + frame,
          next_ele = this.nexts.element.player
          sEle = this.scene.element.player;

      this.maskEle.show();
      sEle.show();
      next_ele.css({
        clipPath: 'polygon(50% 0, 100% 0, 100% 100%, 50% 100%)'
      }).show();
      if(this.video2) {
        this.video2.currentTime = this.nexts.background.element.playerVideo.prop('currentTime') || 0
      }
      this.div1.hide();
      this.div2.css({
        transform: 'rotateY(' + this.linear(_currentFrame, 180, -180, this.totalFrame)+ 'deg)',
      }).show();
    },

    // 清空DOM,以及一些没必要对象
    clearMask: function () {
      this.maskEle.remove();
      this.maskEle = $('<div></div>').attr({id: 'maskEle_' + this.scene.id});
      this.isInit = false;
    }
  }

  // 静态方法
  var statics = {

  }

  if (root.AnimEditor) {
    root.AnimEditor.extendScenesEffect('FlipBook', con, methods, statics);
    return;
  }

  return function (AnimEditor) {
    AnimEditor.extendScenesEffect('FlipBook', con, methods, statics);
  }
});


//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/scene-effects/se-flip-book.js
// module id = NaLj
// module chunks = 16